import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITagResource, ITagTranslation } from "../types";

export interface ITagTranslationQueryParameters {
    tag?: RelationalValue<ITagResource>;
    locale: string;
}

export type ITagTranslationQueryResult = ITagTranslation;

export const tagTranslationQuery: IApiQueryFunction<ITagTranslationQueryParameters> = ({ tag, locale }) => {
    if (!tag) {
        return;
    }

    return {
        method: "GET",
        url: `/tags/${mapRelationalValue(tag)}/translations/${locale}`,
    };
};

export const useTagTranslationQuery = createApiQueryHook<ITagTranslationQueryParameters, ITagTranslationQueryResult>(
    tagTranslationQuery,
);
